import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import HTMLContainer from 'components/common/HTMLContainer/HTMLContainer'
import { H2 } from 'components/common/Text/Text'
import RelatedArticle from './RelatedArticle'

const BOTRelatedArticles = ({ title, items = [], relatedArticles = []}) =>
  <Wrapper>
    <Title data-at-related-articles-title headline narrow centered>{ title }</Title>
    {
      (relatedArticles || []).length ?
        relatedArticles.map(({ articleImage, name, url }) =>
          <RelatedArticle
            key={ name }
            articleImage={ articleImage }
            name={ name }
            url={ url }
            data-at-related-article />
        ) :
        items.map(({ data }, index) =>
          <HTMLContainer key={ index } content={ data } data-at-related-articles />
        )
    }
  </Wrapper>

BOTRelatedArticles.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape()),
  relatedArticles: PropTypes.arrayOf(PropTypes.shape()),
  title: PropTypes.string
}

BOTRelatedArticles.type = 'BOTRelatedArticles'

export default BOTRelatedArticles

const Wrapper = styled.div`
  text-align: center;
  ${Mixin.responsive('margin', '50px auto 40px', '15px 8px 40px')}
`

const Title = styled(H2)`
  ${Mixin.font.GothamBold(26, 600)}
  ${Mixin.responsive('margin', '0 0 15px', '0 8px 12px 8px')}
  ${Media.mobile`
    ${Mixin.font.GothamBold(20, 600)}
  `}
`
